import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "d-flex align-center ga-2" }

import { SystemUser, AuthService, User } from '@/services/auth/authService';
import { onMounted, ref } from 'vue';
import UserFormDialog from '@/components/users/UserFormDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersView',
  setup(__props) {

const authService = new AuthService()
const users = ref<SystemUser[]>([])
const loadingUsers = ref(false)
const userToUpdate = ref<SystemUser | undefined>()
const showUserFormDialog = ref(false)

async function fetchUsers() {
    loadingUsers.value = true
    users.value = await authService.getAllUsers()
    loadingUsers.value = false
}

function showNewUserDialog() {
    userToUpdate.value = undefined
    showUserFormDialog.value = true
}

function showEditUserDialog(user: SystemUser) {
    userToUpdate.value = user
    showUserFormDialog.value = true
}

onMounted(() => {
    fetchUsers()
})

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_list_item_group = _resolveComponent("v-list-item-group")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createTextVNode(" Usuarios "),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "tonal",
                  color: "primary",
                  text: "Agregar usuario",
                  "prepend-icon": "mdi-plus",
                  onClick: showNewUserDialog,
                  size: "small"
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, { elevation: "4" }, {
                default: _withCtx(() => [
                  (loadingUsers.value)
                    ? (_openBlock(), _createBlock(_component_v_list_item_group, {
                        key: 0,
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_skeleton_loader, {
                            class: "mx-auto",
                            type: "list-item",
                            height: 50,
                            width: 400
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_list_item_group, { key: 1 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: user.id,
                              onClick: ($event: any) => (showEditUserDialog(user))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                      _createTextVNode(_toDisplayString(user.name) + " ", 1),
                                      _createVNode(_component_v_spacer),
                                      (user.isAdmin)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 0,
                                            color: "primary",
                                            variant: "tonal",
                                            size: "small",
                                            text: "Administrador"
                                          }))
                                        : _createCommentVNode("", true),
                                      (!user.disabled)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 1,
                                            color: "green",
                                            variant: "tonal",
                                            size: "small",
                                            text: "Activo"
                                          }))
                                        : _createCommentVNode("", true),
                                      (user.disabled)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 2,
                                            color: "red",
                                            variant: "tonal",
                                            size: "small",
                                            text: "Deshabilitado"
                                          }))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Username " + _toDisplayString(user.username), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(UserFormDialog, {
        modelValue: showUserFormDialog.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showUserFormDialog).value = $event)),
        user: userToUpdate.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (userToUpdate.value = undefined)),
        "onUpdate:user": fetchUsers,
        "onCreate:user": fetchUsers
      }, null, 8, ["modelValue", "user"])
    ]),
    _: 1
  }))
}
}

})